// Static catalog — staleTime: Infinity so we hit /space-types once
// per session and never again. New entries land via a backend
// migration (004_layout.sql), not at runtime.

import { useQuery } from "@tanstack/react-query";

import { spaceTypes } from "../api/endpoints/spaceTypes";
import { qk } from "../api/queryKeys";

export function useSpaceTypes() {
  return useQuery({
    queryKey: qk.spaceTypes(),
    queryFn: () => spaceTypes.list().then((r) => r.data),
    staleTime: Infinity,
    gcTime: Infinity,
    refetchOnWindowFocus: false,
  });
}
